import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const communityDriveRegistration: TaskDefinition = {
  taskName: onboardingTasks.CommunityDriveRegistration,
  config: {
    staffDisplayName: ({ data }) =>
      data.customer ? `Community Drive registration - ${data.customer}` : 'Community Drive registration',
    appcuesModalId: 'bc8131fc-6b4a-4769-afaa-0b54d377cd8d',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    autoApprove: true,
    supportsFileUpload: false,
    eventName: 'Community Drive Registration Completed',
    account: {
      content: ({ daysAllowed, data, brandName }) => {
        const driverName = data.customer || 'Driver';
        return {
          title: `Community Drive activation for ${driverName}`,
          incompleteSubtitle: `Keep your Community Drive discount by completing driver activation in the ${brandName} app.`,
          completedSubtitle: 'This driver completed their Community Drive activation.',
          actionLabel: 'Get the App',
          contentSections: [
            {
              title: 'Why this matters',
              body: `Drivers who opt in to our Community Drive telematics program receive a participation discount for the first term. To keep this discount, each participating driver must complete their Community Drive activation in the ${brandName} mobile app within 15 days of the policy start date.`
            },
            {
              title: 'How to complete this task',
              body: `Download the ${brandName} app and follow the prompts to activate Community Drive. Once activation is completed, this task will automatically update to show as approved.`
            },
            {
              title: "What happens if activation isn't completed?",
              body: `If activation isn't completed within ${daysAllowed} days, your participation discount will be removed. Any driver on your policy can activate Community Drive in the ${brandName} mobile app at any time to receive a prorated participation discount.`
            }
          ]
        };
      }
    }
  }
};
